import { ShimmerMetricRow, ShimmerTwoCol } from "./DashboardShimmer";
import "./dashboard-sections.css";

// ── Dummy data (replace with real API data) ──────────────────────────────────
const COLD_DUMMY = {
  total_pallets:          148,
  total_cases:          4320,
  total_fruit_entered:  89600,
};

const RIPENING_DUMMY = {
  total_capacity:         500,
  percentage_occupied:   "72%",
  total_cases:           360,
  total_weight:        18400,
};

// ── Reusable stat row inside a card ─────────────────────────────────────────
const StatRow = ({ label, value, unit, highlight }) => (
  <div className="db-avg-row">
    <span>{label}</span>
    <span className={`db-avg-val${highlight ? " db-highlight" : ""}`}>
      {value}{unit && <span className="db-metric-unit" style={{ marginLeft: 4 }}>{unit}</span>}
    </span>
  </div>
);

// ── Circular progress ring ───────────────────────────────────────────────────
const OccupancyRing = ({ pct = 72 }) => {
  const r = 36;
  const circ = 2 * Math.PI * r;
  const filled = (pct / 100) * circ;
  return (
    <div className="db-ring-wrapper">
      <svg width="90" height="90" viewBox="0 0 90 90">
        <circle cx="45" cy="45" r={r} fill="none" stroke="#f0f1f3" strokeWidth="8" />
        <circle
          cx="45" cy="45" r={r}
          fill="none"
          stroke="#ee7225"
          strokeWidth="8"
          strokeDasharray={`${filled} ${circ}`}
          strokeLinecap="round"
          transform="rotate(-90 45 45)"
        />
      </svg>
      <span className="db-ring-label">{pct}%</span>
    </div>
  );
};

// ── Main component ───────────────────────────────────────────────────────────
const ColdRoomDataOverview = ({
  coldData    = COLD_DUMMY,
  ripeningData = RIPENING_DUMMY,
  isLoading   = false,
}) => {
  const pctNum = parseInt(ripeningData.percentage_occupied) || 0;

  return (
    <div className="db-section">
      <div className="db-section-title">
        <span className="db-title-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/>
          </svg>
        </span>
        Cold + Room Data Overview
      </div>

      {isLoading ? (
        <ShimmerTwoCol />
      ) : (
        <div className="db-two-col">

          {/* ── Cold Storage ── */}
          <div className="db-avg-card">
            <div className="db-avg-header">
              <span className="db-avg-header-title">Cold Storage</span>
              <span className="db-avg-header-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/>
                </svg>
              </span>
            </div>

            {/* Summary metric cards inside cold storage */}
            <div className="db-inner-metric-row">
              <div className="db-inner-metric">
                <div className="db-metric-label">Total Pallets</div>
                <div className="db-metric-value">{coldData.total_pallets?.toLocaleString()}</div>
              </div>
              <div className="db-inner-metric">
                <div className="db-metric-label">Total Cases</div>
                <div className="db-metric-value">{coldData.total_cases?.toLocaleString()}</div>
              </div>
              <div className="db-inner-metric">
                <div className="db-metric-label">Fruit Entered</div>
                <div className="db-metric-value">
                  {coldData.total_fruit_entered?.toLocaleString()}
                  <span className="db-metric-unit">kg</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Ripening Room ── */}
          <div className="db-avg-card">
            <div className="db-avg-header">
              <span className="db-avg-header-title">Ripening Room</span>
              <span className="db-avg-header-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
              </span>
            </div>

            <div className="db-ripening-body">
              {/* Occupancy ring */}
              <div className="db-ripening-ring-col">
                <OccupancyRing pct={pctNum} />
                <span className="db-ring-sublabel">Occupied</span>
              </div>

              {/* Stats */}
              <div className="db-ripening-stats-col">
                <StatRow label="Total Capacity"  value={ripeningData.total_capacity?.toLocaleString()} unit="cases" />
                <StatRow label="Total Cases"     value={ripeningData.total_cases?.toLocaleString()} />
                <StatRow label="Total Weight"    value={ripeningData.total_weight?.toLocaleString()} unit="kg" />
                <StatRow label="% Occupied"      value={ripeningData.percentage_occupied} highlight />
              </div>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default ColdRoomDataOverview;
